import axios from 'axios';
import authManager from './authManager';

// 创建axios实例
const api = axios.create({
  baseURL: '/api', // 使用相对路径，通过代理转发
  timeout: 30000, // 增加超时时间到30秒
});

// 请求拦截器 - 自动添加token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理token过期或无效
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 处理401未授权错误
    if (error?.response?.status === 401) {
      // 排除登录接口和token刷新接口，避免登录失败或刷新失败时也触发登出
      if (!error?.config?.url?.includes('/auth/login') && !error?.config?.url?.includes('/auth/refresh')) {
        console.warn('访问令牌无效，正在跳转到登录页面...');
        // 使用authManager处理强制登出
        authManager.forceLogout();
      }
    }
    
    // 处理访问令牌无效的错误
    if (error?.response?.data?.message === '访问令牌无效') {
      // 排除登录接口和token刷新接口，避免登录失败或刷新失败时也触发登出
      if (!error?.config?.url?.includes('/auth/login') && !error?.config?.url?.includes('/auth/refresh')) {
        console.warn('访问令牌无效，正在跳转到登录页面...');
        // 使用authManager处理强制登出
        authManager.forceLogout();
      }
    }
    
    // 处理403禁止访问错误
    if (error?.response?.status === 403) {
      // 排除token刷新接口，避免刷新失败时触发登出
      if (!error?.config?.url?.includes('/auth/refresh')) {
        console.warn('权限不足，访问被拒绝');
      }
    }
    
    return Promise.reject(error);
  }
);

export default api; 